import React from 'react';
import { Link } from 'react-router-dom';
import { BellIcon, ChevronRightIcon, FileTextIcon, ShieldCheckIcon, WalletIcon } from 'lucide-react';
export type PanelId = 'consentements' | 'factures' | 'confidentialite' | 'atna';
interface Entry {
  id: PanelId | 'notifications';
  title: string;
  description: string;
  icon: typeof BellIcon;
  to?: string;
}
const entries: Entry[] = [{
  id: 'notifications',
  title: 'Notifications',
  description: 'Gérez vos préférences de communication',
  icon: BellIcon,
  to: '/notifications/parametres'
}, {
  id: 'consentements',
  title: 'Consentements',
  description: 'Gérez vos consentements et autorisations',
  icon: ShieldCheckIcon
}, {
  id: 'factures',
  title: 'Mes factures',
  description: 'Consultez vos factures et paiements',
  icon: WalletIcon
}, {
  id: 'confidentialite',
  title: 'Confidentialité et transparence',
  description: 'Comprenez comment vos données et l’IA sont utilisées',
  icon: FileTextIcon
}];
interface AccountNavProps {
  onOpen: (panel: PanelId) => void;
}
export function AccountNav({
  onOpen
}: AccountNavProps) {
  return <section aria-labelledby="compte-titre" data-id="element-2695" data-mp="3qyttwchl6jzo">
      <h2 id="compte-titre" className="text-sm font-bold uppercase tracking-wider text-slate-500" data-id="element-2696" data-mp="8rcqma1n8fnh">
        Gérer mon compte
      </h2>
      <ul className="mt-3 space-y-2" data-id="element-2697" data-mp="3st0ryjxijpu">
        {entries.map(entry => {
        const shared = 'group flex w-full items-center gap-4 rounded-2xl border border-slate-200 bg-white px-4 py-3.5 text-left transition-colors duration-150 ease-ville hover:border-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo';
        const inner = <>
              <span className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-slate-100 text-ville-navy transition-colors duration-150 ease-ville group-hover:bg-ville-indigo-soft group-hover:text-ville-indigo" aria-hidden="true" data-id="element-2698" data-mp="3h5lbsx1u645m">
                <entry.icon className="h-5 w-5" data-id="element-2699" data-mp="sekoug0w820e" />
              </span>
              <span className="min-w-0 flex-1" data-id="element-2700" data-mp="xdf5pcfavghv">
                <span className="block text-[15px] font-bold text-ville-navy" data-id="element-2701" data-mp="xc41jbhy06q8">{entry.title}</span>
                <span className="block text-sm leading-snug text-slate-500" data-id="element-2702" data-mp="12706tdc6wqla">{entry.description}</span>
              </span>
              <ChevronRightIcon className="h-5 w-5 shrink-0 text-slate-400 transition-colors duration-150 ease-ville group-hover:text-ville-indigo" aria-hidden="true" data-id="element-2703" data-mp="9g86c3o3dfs5" />
            </>;
        return <li key={entry.id} data-id="element-2704" data-mp="jcuqsrcia4tn">
              {entry.to ? <Link to={entry.to} className={shared} data-id="element-2705" data-mp="ng9g68mc3xjr">
                  {inner}
                </Link> : <button type="button" onClick={() => onOpen(entry.id as PanelId)} className={shared} data-id="element-2706" data-mp="1ust4x9mjjh1q">
                  {inner}
                </button>}
            </li>;
      })}
      </ul>
    </section>;
}